import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import legalEntityAttendanceReadAction from './legalEntityAttendanceRead.action.json' assert { type: 'json' }

const attendanceReadDefinition = defineReadAutoAction(
  legalEntityAttendanceReadAction,
  'legalEntityAttendance',
)

export default attendanceReadDefinition
